export const getOptionTimer = times =>
  times.map(t => ({
    label: t,
    value: t,
  }));
